var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState, } from 'react';
import { C } from '#integrations';
import { debounceRAF } from '#services';
import { Box } from '../Box';
import { ChevronRightIcon } from '../icons';
import { Typography } from '../Typography';
import { BreadcrumbLink } from './BreadcrumbLink';
import { BreadcrumbMoreMenu } from './components';
import { BreadcrumbTestIdFactory } from './interactions';
import styles from './Breadcrumb.module.css';
const RESIZE_OBSERVER_DEBOUNCE_INTERVAL = 300;
export const Breadcrumb = ({ className, 'data-testid': testId, entries, isLoading = false, LeadingIcon, menuButtonLabel, onSelect, pathField, rootName, textField, }) => {
    _react_refresh_temp_2();
    const containerRef = useRef(null);
    const [shouldCheckAgain, setShouldCheckAgain] = useState(false);
    const [shouldRenderInMenu, setShouldRenderInMenu] = useState(false);
    const checkContainerWidth = useCallback(() => {
        const newContainerWidth = containerRef.current?.offsetWidth;
        const containerScrollWidth = containerRef.current?.scrollWidth;
        if (newContainerWidth !== undefined &&
            containerScrollWidth !== undefined) {
            if (containerScrollWidth > newContainerWidth) {
                setShouldRenderInMenu(true);
            }
            if (containerScrollWidth <= newContainerWidth) {
                setShouldCheckAgain(true);
                setShouldRenderInMenu(false);
            }
        }
    }, []);
    useEffect(() => {
        checkContainerWidth();
    }, [checkContainerWidth, entries]);
    useLayoutEffect(() => {
        if (shouldCheckAgain) {
            const newContainerWidth = containerRef.current?.offsetWidth;
            const containerScrollWidth = containerRef.current?.scrollWidth;
            if (newContainerWidth !== undefined &&
                containerScrollWidth !== undefined &&
                containerScrollWidth > newContainerWidth) {
                setShouldRenderInMenu(true);
            }
            setShouldCheckAgain(false);
        }
    }, [shouldCheckAgain]);
    const observerRef = useRef(
    // TODO: https://lucidlink.atlassian.net/browse/LUCID-19094
    // Implement singleton ResizeObserver
    new ResizeObserver(debounceRAF(checkContainerWidth, RESIZE_OBSERVER_DEBOUNCE_INTERVAL)));
    useEffect(() => {
        const container = containerRef?.current;
        const observer = observerRef.current;
        if (container) {
            observer.observe(container);
        }
        return () => {
            if (container) {
                observer.unobserve(container);
            }
        };
    }, []);
    const moreMenuEntries = useMemo(() => entries.slice(1, entries.length - 1), [entries]);
    return (_jsx("div", { className: C(styles.Container, className), ref: containerRef, children: _jsx(Box, { align: "center", "data-testid": BreadcrumbTestIdFactory.getBreadcrumbTestId(testId), gap: "xs", children: isLoading ? (_jsxs("div", { className: styles.LoadingContainer, children: [_jsx(LeadingIcon, { className: styles.LoadingIcon, color: "accent", size: "xsmall" }), _jsx("div", { className: styles.LoadingBar, "data-testid": BreadcrumbTestIdFactory.getBreadcrumbLoadingTestId(testId) })] })) : entries.length ? (entries.map((entry, index) => 
            // Always render the first and last item in the Breadcrumb
            index === 0 || index === entries.length - 1 ? (_jsx(BreadcrumbLink, { "data-testid": BreadcrumbTestIdFactory.internalGenerateBreadcrumbLinkTestId(testId, index), entry: entry, isCurrent: index === entries.length - 1, isRoot: index === 0, LeadingIcon: LeadingIcon, onSelect: onSelect, shouldTruncateRoot: shouldRenderInMenu, textField: textField }, entry[pathField])) : shouldRenderInMenu ? (_jsx(Fragment, { children: index === 1 && (_jsxs(_Fragment, { children: [_jsx(BreadcrumbMoreMenu, { "data-testid": testId, entries: moreMenuEntries, menuButtonLabel: menuButtonLabel, onSelect: onSelect, pathField: pathField, textField: textField }), _jsx(ChevronRightIcon, { size: "xsmall" })] })) }, index)) : (_jsx(BreadcrumbLink, { "data-testid": BreadcrumbTestIdFactory.internalGenerateBreadcrumbLinkTestId(testId, index), entry: entry, isCurrent: index === entries.length - 1, isRoot: index === 0, LeadingIcon: LeadingIcon, onSelect: onSelect, textField: textField }, entry[pathField])))) : (
            // In some scenarios data for the inner entries may not be initially available
            // For those cases displaying the root for a moment is a fallback so that we do not display loading
            _jsxs(Box, { gap: "s", padding: "xs 0", children: [_jsx(LeadingIcon, { color: "accent", size: "xsmall" }), _jsx(Typography, { color: "accent", kind: "generic", children: rootName })] })) }) }));
};
_react_refresh_temp_1 = Breadcrumb;
$RefreshReg$(_react_refresh_temp_1, "Breadcrumb");
_react_refresh_temp_2(Breadcrumb, "2XLfawzpEh5xFy8g08D3VZ/GgL8=");
